import React from 'react'

const Dashboard = () => {
  return (
    <div className='container text-center'> 
        <h1> This is the overall dashboard </h1>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat ea deserunt at omnis consequatur. Aliquam ipsa dicta animi modi eligendi obcaecati at saepe quos iste. Error odio ad ipsa vel!
    </div>
  )
}

export default Dashboard